import { DoesFilterPassParams } from "ag-grid-enterprise";

const BLANKS_KEY = "(Blanks)";

export const doesFilterPass: ({
  model,
  node,
  handlerParams
}: DoesFilterPassParams<any, any, any>) => boolean = ({
  model,
  node,
  handlerParams
}: DoesFilterPassParams<any, any, any>) => {
  const values = handlerParams.getValue(node);

  const pathsArray = values.map((value: any) => {
    return value.path || "";
  });
  if (pathsArray.length === 0) {
    return model.values.some((key: any) => key === BLANKS_KEY);
  }
  if (model.values.length > 0) {
    return model.values.some((key: any) =>
      pathsArray.includes(key.toString().replace(BLANKS_KEY, ""))
    );
  }
  return false;
};
